import { supabase } from '@/lib/supabase'
import type { District, DistrictCreate, DistrictUpdate } from '@/types'

export async function fetchDistrictsByRegion(regionId: string): Promise<District[]> {
  const { data, error } = await supabase
    .from('districts')
    .select('*')
    .eq('region_id', regionId)
    .order('name', { ascending: true })

  if (error) {
    throw error
  }

  return data as District[]
}

export async function fetchDistrictsByNation(nationId: string): Promise<District[]> {
  const { data, error } = await supabase
    .from('districts')
    .select('*, region:regions!inner(nation_id)')
    .eq('region.nation_id', nationId)
    .order('name', { ascending: true })

  if (error) {
    throw error
  }

  return data as District[]
}

export interface DistrictWithRegion extends District {
  region: {
    id: string
    name: string
    region_type: import('@/types').RegionType
  }
}

export async function fetchDistrictsWithRegionByNation(
  nationId: string
): Promise<DistrictWithRegion[]> {
  const { data, error } = await supabase
    .from('districts')
    .select('*, region:regions!inner(id, name, nation_id, region_type)')
    .eq('region.nation_id', nationId)
    .order('name', { ascending: true })

  if (error) {
    throw error
  }

  return data as DistrictWithRegion[]
}

export async function fetchDistrict(id: string): Promise<District> {
  const { data, error } = await supabase.from('districts').select('*').eq('id', id).single()

  if (error) {
    throw error
  }

  return data as District
}

export async function createDistrict(district: DistrictCreate): Promise<District> {
  const { data, error } = await supabase.from('districts').insert(district).select().single()

  if (error) {
    throw error
  }

  return data as District
}

export async function updateDistrict(id: string, updates: DistrictUpdate): Promise<District> {
  const { data, error } = await supabase
    .from('districts')
    .update(updates)
    .eq('id', id)
    .select()
    .single()

  if (error) {
    throw error
  }

  return data as District
}

export async function deleteDistrict(id: string): Promise<void> {
  const { error } = await supabase.from('districts').delete().eq('id', id)

  if (error) {
    throw error
  }
}
